module.exports = __webpack_public_path__ + "media/images/home/seamless-0d37cdb9e4486320c4b954759f7e94c8.png";